/**
 * Выжимка часов других форманов с сервера → в форму грида.
 *
 * Сервер шлёт компактно (лист большой, pull частый): словари форманов и работ
 * плюс строки [субъект, день 0..6, автор, работа, часы, создано unix-сек].
 * Субъект уже в форме листа: temp — отрицательный id. День — смещение от
 * понедельника недели, которая кончается weekEnding (воскресенье).
 */
export function decodeOthersHours(weekEnding, snap) {
    const sunday = new Date(weekEnding + 'T00:00:00');
    const dates = [];
    for (let i = 6; i >= 0; i--) {
        const d = new Date(sunday);
        d.setDate(sunday.getDate() - i);
        dates.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
    }
    const authors = snap.authors || [];
    const jobs = snap.jobs || [];
    return (snap.rows || []).map(([subj, day, a, j, hours, created], i) => {
        const job = jobs[j] || [];
        return {
            clientId: `${subj}|${day}|${a}|${j}|${i}`,
            employeeId: Number(subj),
            jobId: job[0] ?? null,
            jobCode: job[1] || '',
            jobName: job[2] || '',
            workDate: dates[day],
            hours: Number(hours) || 0,
            createdByName: authors[a] || '',
            createdAt: created ? new Date(created * 1000).toISOString() : null,
        };
    });
}
